/*
To Do:
- Update pagination function to generate the correct number of buttons
- Add all filters to the Cloudflare Worker
- Connect helpful button to Cloudflare Worker
- Fix pagination styles
- Add no filtered reviews message
- If there are no reviews or null reviews, hide the reviews section
*/

window.addEventListener('load', (event) => {
  const ratingSelector = '.reviews[data-product-id], .product-review-score[data-product-id]';
  const ratingElements = document.querySelectorAll(ratingSelector);

  ratingElements.forEach((element) => {
    const productId = element.dataset.productId ?? '';
    const productHandle = element.dataset.productHandle ?? '';
    getReviewsStars(productId, productHandle);
  });

  const reviewModules = document.getElementsByClassName('reviews');

  for (const reviewModule of reviewModules) {
    const productId = reviewModule.dataset.productId ?? '';
    const productHandle = reviewModule.dataset.productHandle ?? '';
    if (!productId) continue;
    getReviews(reviewModule.dataset.productId, null, null, reviewModule.dataset.productHandle);
    applyFilters(reviewModule.dataset.productId);
    initPagination(reviewModule.dataset.productId);
  }
});

// Stars and Review Count
function getReviewsStars(productId, productHandle) {
  const payload = { 'product-id': productId, ...(productHandle && { 'product-handle': productHandle }) };

  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: JSON.stringify(payload),
    redirect: 'follow',
  };

  fetch('https://product-rating.sodasense.workers.dev/', requestOptions)
    .then((response) => response.json())
    .then((result) => {
      populateReviewsStars(productId, result);
      createReviewsFilters(productId, result);
    })
    .catch((error) => console.log('error', error));
}

function populateReviewsStars(productId, reviewData) {
  const reviewScore = document.querySelector(`.product-review-score[data-product-id="${productId}"]`);
  if (!reviewScore) return;

  const count = parseInt(reviewData.review_score_count, 10);
  if (!Number.isFinite(count)) {
    reviewScore.hidden = true;
    return;
  }

  reviewScore.innerHTML = `${count.toLocaleString()} Reviews`;
  reviewScore.setAttribute('style', `--rating: ${reviewData.review_score_average}`);
  reviewScore.setAttribute('aria-label', `Rating of this product is ${reviewData.review_score_average} out of 5.`);
  reviewScore.addEventListener('click', (event) => {
    document.querySelector(`.reviews[data-product-id="${productId}"]`).scrollIntoView({ behavior: 'smooth' });
  });
}

// Filters
const reviewFilters = {};

// Rating Filter
function createReviewsFilters(productId, reviewData) {
  const reviewsContainer = document.querySelector(`.reviews[data-product-id="${productId}"]`);

  if (!reviewsContainer) {
    return;
  }

  const count = parseInt(reviewData.review_score_count, 10);
  if (!Number.isFinite(count)) {
    return;
  }

  reviewsContainer.querySelector('.average-score').textContent = reviewData.review_score_average;
  reviewsContainer.querySelector('.average-score-stars').setAttribute('style', `--rating: ${reviewData.review_score_average}`);
  reviewsContainer.querySelector('.total-reviews-count').textContent = `Based on ${count.toLocaleString()} Reviews`;

  reviewsContainer.querySelectorAll('[data-filter-review]').forEach(starFilter => {
    const starValue = parseInt(starFilter.getAttribute('data-filter-review'));
    const starBarFill = starFilter.querySelector('.star-bar-fill');
    const starCountText = starFilter.querySelector(`.n${starValue}-star-review-count`);
    const starCount = reviewData[`n${starValue}_star_review_count`];

    starBarFill.style.width = `${Math.ceil((starCount / reviewData.review_score_count) * 100)}%`;
    starCountText.textContent = parseInt(starCount).toLocaleString();
  });

  const ratingButtons = document.querySelectorAll('[data-filter-review]');

  ratingButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const rating = button.dataset.filterReview;
      const currentPage = document.querySelector('.pagination__page-active').textContent;
      getReviews(productId, currentPage, rating);
    });
  });
}

function applyFilters(productId) {
  const filterDropdownToggles = document.querySelectorAll(`.reviews[data-product-id="${productId}"] [data-dropdown-toggle]`);

  filterDropdownToggles.forEach(toggleElement => {
    const dropdownId = toggleElement.getAttribute('data-dropdown-toggle');
    const dropdown = document.getElementById(dropdownId);
    const filterItems = dropdown.querySelectorAll('button[role="menuitem"]');

    filterItems.forEach(item => {
      item.addEventListener('click', function () {
        const dataAttrs = item.dataset;
        const filterName = Object.keys(dataAttrs)[0];
        const filterValue = dataAttrs[filterName];

        // Instantiate the dropdown again so we have access to its methods later
        const openDropdown = new Dropdown(dropdown, toggleElement, {});

        // Remove any existing SVG from the item
        const existingSVG = item.querySelector('svg');
        if (existingSVG) {
          existingSVG.remove();
        }

        // Check for an existing active filter from the same category
        const activeSiblingFilter = document.querySelector(`#appliedFilters button[data-filter-name="${filterName}"]`);
        if (activeSiblingFilter) {
          const activeFilterValue = activeSiblingFilter.dataset.filterValue;
          delete reviewFilters[filterName];
          activeSiblingFilter.remove();

          // Remove the SVG from the previously active filter item
          const previousFilterItem = dropdown.querySelector(`button[role="menuitem"][data-${filterName}="${activeFilterValue}"]`);
          if (previousFilterItem) {
            const prevSVG = previousFilterItem.querySelector('svg');
            if (prevSVG) prevSVG.remove();
          }

          // If clicked the same filter that's already active, stop further processing
          if (activeFilterValue === filterValue) {
            getReviews(productId);
            openDropdown.hide();
            return;
          }
        }

        // Update the filters object
        reviewFilters[filterName] = filterValue;

        // Insert the SVG to the clicked item
        const svg = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.6 15.8105L9.24645 15.457L5.29833 11.5089C5.1666 11.383 4.99095 11.3134 4.80866 11.315C4.62513 11.3166 4.44956 11.3902 4.31977 11.52C4.18999 11.6498 4.11637 11.8254 4.11477 12.0089C4.11319 12.1912 4.18277 12.3668 4.30864 12.4986L9.1051 17.295C9.10512 17.295 9.10514 17.2951 9.10515 17.2951C9.23642 17.4263 9.41441 17.5 9.6 17.5C9.78559 17.5 9.96358 17.4263 10.0948 17.2951L10.0949 17.295M9.6 15.8105L20.0484 6.35183C20.2734 6.57687 20.3997 6.88203 20.3997 7.20023C20.3997 7.51843 20.2734 7.8236 20.0484 8.04863L10.4484 17.6486L10.0949 17.295M9.6 15.8105L9.95355 15.457L18.7051 6.70544C18.7051 6.70542 18.7051 6.7054 18.7052 6.70539C18.8364 6.57419 19.0144 6.50049 19.2 6.50049C19.3856 6.50049 19.5636 6.57421 19.6949 6.70544M9.6 15.8105L19.6949 6.70544M10.0949 17.295L19.6948 7.69513C19.6948 7.69511 19.6948 7.6951 19.6948 7.69508C19.826 7.56381 19.8997 7.38582 19.8997 7.20023C19.8997 7.01467 19.8261 6.8367 19.6949 6.70544M10.0949 17.295L19.6949 6.70544" fill="#003567" stroke="#168EFF"/></svg>`;
        item.insertAdjacentHTML('beforeend', svg);

        // Create and display the applied filter button
        const appliedFiltersDiv = document.querySelector('#appliedFilters');
        const template = document.querySelector('#applied-filter').content.cloneNode(true);
        const button = template.querySelector('button');
        button.dataset.filterName = filterName;
        button.dataset.filterValue = filterValue;

        if (filterName === 'rating') {
          const rating = parseInt(filterValue);
          button.setAttribute('style', `--rating: ${rating}`);
          button.dataset.rating = rating;
          button.classList.add('stars');
        } else {
          button.insertAdjacentHTML('afterbegin', item.textContent);
        }

        button.addEventListener('click', function () {
          delete reviewFilters[filterName];
          appliedFiltersDiv.removeChild(button);
          const filterItemForButton = dropdown.querySelector(`button[role="menuitem"][data-${filterName}="${filterValue}"]`);
          if (filterItemForButton) {
            const svgForButton = filterItemForButton.querySelector('svg');
            if (svgForButton) svgForButton.remove();
          }
          getReviews(productId);
        });

        appliedFiltersDiv.appendChild(template);
        getReviews(productId);
        openDropdown.hide();
      });
    });
  });
}

// Reviews
async function getReviews(productId, page, rating, productHandle) {
  const handle = productHandle ?? document.querySelector(`.reviews[data-product-id="${productId}"]`)?.dataset?.productHandle;
  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');

  const payload = {
    'product-id': productId,
    ...reviewFilters,
    ...(handle && { 'product-handle': handle }),
  };

  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: JSON.stringify(payload),
    redirect: 'follow'
  };

  try {
    const response = await fetch('https://reviews.sodasense.workers.dev/', requestOptions);
    const result = await response.json();
    const reviewsList = Array.isArray(result?.results) ? result.results : [];
    populateReviews(productId, reviewsList ?? []);
    return true;
  } catch (error) {
    console.log('error', error);
    return false;
  }
}

function populateReviews(productId, reviews) {
  const list = Array.isArray(reviews) ? reviews : [];
  const reviewsContainer = document.querySelector(`.reviews[data-product-id="${productId}"]`);
  if (!reviewsContainer) return;
  const reviewsWrapper = reviewsContainer.querySelector('.reviews-wrapper');
  const template = document.getElementById('review-template');
  if (!reviewsWrapper || !template) return;
  const toRemove = [...reviewsWrapper.children].filter(child => child !== template);
  toRemove.forEach(child => reviewsWrapper.removeChild(child));

  list.forEach((review) => {
    // Clone the template content
    const clone = template.content.cloneNode(true);

    // Populate the clone with review data
    const date = new Date(review.properties.review_creation_date);
    let options = {
      year: '2-digit',
      month: '2-digit',
      day: '2-digit',
    };

    // Add the review id to the review container
    clone.querySelector('.review').setAttribute('data-review-id', review.id);
    clone.querySelector('.reviewer-initial').textContent = review.properties.reviewer_display_name.charAt(0);
    clone.querySelector('.reviewer-display-name').textContent = review.properties.reviewer_display_name;
    clone.querySelector('.review-score').setAttribute('data-product-id', productId);
    clone.querySelector('.review-score').setAttribute('style', `--rating: ${review.properties.review_score}`);
    clone.querySelector('.review-score').setAttribute('aria-label', `Rating of this product is ${review.properties.review_score} out of 5.`);
    clone.querySelector('.review-title').textContent = review.properties.title;
    clone.querySelector('.review-content').textContent = review.properties.review_content;
    clone.querySelector('.review-date').setAttribute('datetime', date);
    clone.querySelector('.review-date').textContent = new Intl.DateTimeFormat('en-US', options).format(date);
    /* clone.querySelector('.helpful-count').textContent = review.properties.thumbs_up;
    clone.querySelector('.not-helpful-count').textContent = review.properties.thumbs_down; */

    // Append the populated clone to the reviews container
    reviewsWrapper.appendChild(clone);
  });
  // initHelpfulButtons(productId);
}

// Helpful/Not Helpful Buttons
/* function initHelpfulButtons(productId) {
  const initButton = (button, cookieName) => {
    const cookie = document.cookie.split(';').find(cookie => cookie.trim().startsWith(cookieName));
    const helpfulButton = button.closest('.review').querySelector('button.helpful');
    const notHelpfulButton = button.closest('.review').querySelector('button.not-helpful');
    if (cookie) {
      helpfulButton.disabled = true;
      notHelpfulButton.disabled = true;
    }
    button.addEventListener('click', (event) => {
      const reviewId = event.target.closest('.review').dataset.reviewId;
      document.cookie = `${cookieName}=true; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/`;
      helpfulButton.disabled = true;
      notHelpfulButton.disabled = true;
      updateHelpfulCount(reviewId, button.classList.contains('helpful'), button);
    });
  };

  const helpfulButtons = document.querySelectorAll(`.reviews[data-product-id="${productId}"] button.helpful`);
  helpfulButtons.forEach(button => initButton(button, `helpful-${button.closest('.review').dataset.reviewId}`));

  const notHelpfulButtons = document.querySelectorAll(`.reviews[data-product-id="${productId}"] button.not-helpful`);
  notHelpfulButtons.forEach(button => initButton(button, `helpful-${button.closest('.review').dataset.reviewId}`));
} */

/* async function updateHelpfulCount(reviewId, helpful, button) {
  const endpoint = "https://reviews-helpful.sodasense.workers.dev/";

  const requestBody = {
    "review-id": reviewId,
    "helpful": helpful
  };

  try {
    const response = await fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(requestBody)
    });

    const responseData = await response.json();
    if (response.ok) {
      const span = button.querySelector('span');
      span.textContent = parseInt(span.textContent) + 1;
    } else {
      console.error("Error updating review feedback:", responseData.error);
    }
  } catch (error) {
    console.error("Network or other error:", error);
  }
} */

// Pagination
function initPagination(productId) {
  let currentPage = parseInt(document.querySelector(`.reviews[data-product-id="${productId}"] .pagination__page-active`).textContent) || 1;

  // Page buttons
  let buttons = Array.from(
    document.querySelectorAll(
      `.reviews[data-product-id="${productId}"] [class^="pagination__page"]:not(.previous):not(.next)`,
    ),
  );

  buttons.forEach((button) => {
    button.addEventListener('click', (event) => {
      let pageNumber = parseInt(event.target.textContent);
      changePage(productId, pageNumber);
    });
  });

  // Previous page
  document.querySelector(`.reviews[data-product-id="${productId}"] .previous.pagination__page`).addEventListener('click', () => {
    let previousPage = currentPage - 1;
    changePage(productId, previousPage);
  });

  // Next page
  document.querySelector(`.reviews[data-product-id="${productId}"] .next.pagination__page`).addEventListener('click', () => {
    let nextPage = currentPage + 1;
    changePage(productId, nextPage);
  });
}

function changePage(productId, pageNumber) {
  let currentPage = parseInt(document.querySelector(`.reviews[data-product-id="${productId}"] .pagination__page-active`).textContent) || 1;
  let currentElement = document.querySelector(`.reviews[data-product-id="${productId}"] #pagination_page-${currentPage}`);

  if (currentElement) { // Ensure currentElement exists
    currentElement.classList.remove('pagination__page-active');
    currentElement.classList.add('pagination__page');
  }

  updatePageButtons(productId, pageNumber);

  let newElement = document.querySelector(`.reviews[data-product-id="${productId}"] #pagination_page-${pageNumber}`);
  if (newElement) { // Ensure newElement exists
    newElement.classList.add('pagination__page-active');
  }

  // Update the filters object with the new page number
  reviewFilters.page = pageNumber;
  getReviews(productId);
  document.querySelector(`.reviews[data-product-id="${productId}"]`).scrollIntoView({ behavior: 'smooth' });
}

function updatePageButtons(productId, pageNumber) {
  let currentSetStart = Math.floor((pageNumber - 1) / 5) * 5 + 1;

  let buttons = Array.from(
    document.querySelectorAll(
      `.reviews[data-product-id="${productId}"] [class^="pagination__page"]:not(.previous):not(.next)`,
    ),
  );

  buttons.forEach((button, index) => {
    let newPageNumber = currentSetStart + index;
    button.textContent = newPageNumber;
    button.id = `pagination_page-${newPageNumber}`;
    button.classList.remove('pagination__page-active');
    if (newPageNumber === pageNumber) {
      button.classList.add('pagination__page-active');
    }
  });
}